import { render, staticRenderFns } from "./SpecsRelationShop.vue?vue&type=template&id=6c9443b4"
import script from "./SpecsRelationShop.vue?vue&type=script&lang=js"
export * from "./SpecsRelationShop.vue?vue&type=script&lang=js"
import style0 from "./SpecsRelationShop.vue?vue&type=style&index=0&id=6c9443b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports